import React from 'react';
import { Link } from 'react-router-dom';
import { isVideo } from '../../utils/utils';
import SkeletonLoading from '../Layouts/SkeletonLoading/SkeletonLoading';
import './SearchResult.css';
import { useS3Image } from '../../hooks/useS3Image';

const LISTING_URL = process.env.REACT_APP_LISTING_SERVICE || 'http://localhost:4001';
const PROFILE_SERVICE = process.env.REACT_APP_PROFILE_SERVICE || 'http://localhost:4002';

// NFT Card Component - Using NFTItem design
export const NFTCard = ({ nft, handleViewClick }) => {

    let fileType = isVideo(nft?.resource_type) ? "videos" : "images"
    const { resourceUrl, loading, error } = useS3Image(nft?.resource_url, fileType);

    if (!nft) return null;






    return (
        <div className="nft-card">
            <div className="nft-card-content">
                {/* Title and Token ID */}
                <div className="main mb-3 align-items-center nucin">
                    <div className="left">
                        <h6 className="HeadingEllipsis mb-0">
                            {nft?.title}
                        </h6>
                    </div>
                    <div className="right block-typ">
                        <div className="category-icon ms-auto">
                            {nft.blockchain_token_id && (
                                <span id="numbers">#{nft?.blockchain_token_id}</span>
                            )}
                        </div>
                    </div>
                </div>

                {/* Image Section */}
                <Link to={`/detail/${nft.nft_id}`}>
                    <div className="image mb-3">
                        {isVideo(nft?.resource_type) ? (
                            <video key={resourceUrl} autoPlay loop muted playsInline>
                                <source src={resourceUrl} type="video/mp4" />
                            </video>
                        ) : (
                            <img
                                src={resourceUrl}
                                alt={nft.title || "NFT"}
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = '/images/placeholder.png';
                                }}
                            />
                        )}

                        {/* Status Badge */}
                        {nft?.on_sale && (
                            <div className="status-badge sale-badge">
                                <span>On Sale</span>
                            </div>
                        )}
                    </div>
                </Link>

                {/* Owner Info */}
                {nft.creator_username && (
                    <div className="owner-section mb-3">
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="owner-icon"
                        >
                            <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="2" />
                            <path
                                d="M4 20C4 16.6863 6.68629 14 10 14H14C17.3137 14 20 16.6863 20 20"
                                stroke="currentColor"
                                strokeWidth="2"
                            />
                        </svg>
                        <span className="owner-label-text">Created by</span>
                        <Link to={`/profile/${nft.creator_username}`}>
                            <span className="owner-text">
                                {nft.creator_username}
                            </span>
                        </Link>
                    </div>
                )}

                {/* Bottom Info - Price (Left) and Created Time (Right) */}
                <div className="main align-items-center mb-3">
                    <div className="left">
                        <span className="price-label">Price</span>
                        <span className="price-value">
                            {nft.price || '0'} NUC
                        </span>
                    </div>
                    <div className="right text-end">
                        <span className="info-label">Status</span>
                        <span className="info-value">
                            {nft.on_sale ? 'On Sale' : nft.status || 'N/A'}
                        </span>
                    </div>
                </div>

                {/* View Detail Button */}
                <button
                    onClick={() => handleViewClick && handleViewClick(nft)}
                    className="view-detail-btn"
                >
                    View Details
                </button>
            </div>
        </div>
    );
};

// User Card Component
export const UserCard = ({ user, handleViewClick }) => {
    if (!user) return null;

    const profileImageUrl = user.profile_image
        ? `${PROFILE_SERVICE}/v1/profile/image/${user.username}`
        : '/images/user.png';

    return (
        // Commented out profile link - can be enabled later if needed
        // <Link to={`/profile/${user.username}`} className="search-result-card-link">
        <div className="search-result-card-link">
            <div className="search-result-card user-card">
                <div className="user-card-header">
                    <img
                        src={profileImageUrl}
                        alt={user.display_name || user.username}
                        className="user-avatar"
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = '/images/user.png';
                        }}
                    />
                    <div className="user-verified-badge">
                        <i className="fas fa-check-circle"></i>
                    </div>
                </div>
                <div className="user-card-content">
                    <h3 className="user-display-name" title={user.display_name || user.username}>
                        {user.display_name || user.username}
                    </h3>
                    <p className="user-username" title={user.username}>
                        @{user.username}
                    </p>
                    {user.full_name && (
                        <p className="user-full-name" title={user.full_name}>
                            {user.full_name}
                        </p>
                    )}
                    {user.email && (
                        <p className="user-email" title={user.email}>
                            <i className="fas fa-envelope"></i> {user.email}
                        </p>
                    )}
                    {user.public_address && (
                        <div className="user-address" title={user.public_address}>
                            <i className="fas fa-wallet"></i>
                            <span className="address-text">
                                {user.public_address.substring(0, 6)}...{user.public_address.substring(user.public_address.length - 4)}
                            </span>
                        </div>
                    )}
                </div>
                {/* Commented out View Profile button - can be enabled later if needed */}
                <div className="user-card-footer">
                    <span style={{ cursor: "pointer" }} onClick={() => handleViewClick && handleViewClick(user)} className="view-profile-btn">
                        View Profile <i className="fas fa-arrow-right"></i>
                    </span>
                </div>
            </div>
        </div>
        // </Link>
    );
};

// Skeleton Loading Component
export const SkeletonCard = ({ type = 'nft' }) => {
    if (type === 'user') {
        return (
            <div className="search-result-card user-card skeleton-card">
                <div className="user-card-header">
                    <div className="skeleton-avatar"></div>
                </div>
                <div className="user-card-content">
                    <div className="skeleton-line" style={{ width: '70%', height: '20px', marginBottom: '8px' }}></div>
                    <div className="skeleton-line" style={{ width: '50%', height: '16px', marginBottom: '12px' }}></div>
                    <div className="skeleton-line" style={{ width: '90%', height: '14px', marginBottom: '6px' }}></div>
                    <div className="skeleton-line" style={{ width: '60%', height: '14px' }}></div>
                </div>
            </div>
        );
    }

    // NFT Skeleton matching NFTItem design
    return (
        <div className="nft-card">
            <div className="nft-card-content">
                {/* Title and Token ID Skeleton */}
                <div className="main mb-3 align-items-center nucin" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div className="left">
                        <SkeletonLoading width={130} height={16} />
                    </div>
                    <div className="right block-typ">
                        <div className="category-icon ms-auto">
                            <SkeletonLoading width={38} height={24} style={{ borderRadius: "6px" }} />
                        </div>
                    </div>
                </div>

                {/* Image Skeleton */}
                <div className="image mb-3">
                    <SkeletonLoading style={{ width: "100%", height: "260px", borderRadius: "16px" }} />
                </div>

                {/* Owner Info Skeleton */}
                <div className="owner-section mb-3" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <SkeletonLoading width={16} height={16} style={{ borderRadius: "4px" }} />
                    <SkeletonLoading width={60} height={14} />
                    <SkeletonLoading width={90} height={14} />
                </div>

                {/* Bottom Info - Price and Status Skeleton */}
                <div className="main align-items-center mb-3" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div className="left" style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                        <SkeletonLoading width={35} height={11} />
                        <SkeletonLoading width={75} height={20} />
                    </div>
                    <div className="right text-end" style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'flex-end' }}>
                        <SkeletonLoading width={70} height={11} />
                        <SkeletonLoading width={90} height={14} />
                    </div>
                </div>

                {/* Button Skeleton */}
                <div className="skeleton-button-wrapper">
                    <SkeletonLoading style={{ width: "100%", height: "44px", borderRadius: "8px" }} />
                </div>
            </div>
        </div>
    );
};

